module.exports = __webpack_public_path__ + "static/media/Item_Weapon_AUG_C.23735ccf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/item/Weapon/Main/Item_Weapon_AUG_C.png
// module id = ./src/assets/item/Weapon/Main/Item_Weapon_AUG_C.png
// module chunks = 0